import * as React from 'react';
import { Button } from '@/components/forms/ui/button';
import { cn } from '@/lib/utils';

type LiteralSelectFieldProps<T extends string> = {
  value: T;
  options: ReadonlyArray<T>;
  onChange: (value: T) => void;
  label?: React.ReactNode;
  disabled?: boolean;
  allowDeselect?: boolean;
  className?: string;
};

export function LiteralSelectField<T extends string>({
  value,
  options,
  onChange,
  label,
  disabled = false,
  allowDeselect = false,
  className
}: LiteralSelectFieldProps<T>) {
  const handleClick = (next: T) => {
    if (allowDeselect && value === next) return;
    onChange(next);
  };

  return (
    <div className={cn('flex flex-col gap-1', className)}>
      {label ? <span className="text-sm font-medium">{label}</span> : null}
      <div className="flex flex-wrap gap-2">
        {options.map(opt => {
          const isActive = opt === value;
          return (
            <Button
              key={opt}
              type="button"
              variant={isActive ? 'default' : 'outline'}
              onClick={() => handleClick(opt)}
              aria-pressed={isActive}
              disabled={disabled}
              className={cn(
                'h-9 border px-2 font-light capitalize',
                isActive ? 'border-transparent' : 'border-input'
              )}>
              {opt}
            </Button>
          );
        })}
      </div>
    </div>
  );
}
